// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2rRMI","range":"MonthRangeSwitch_range__1s3Lp","disabled":"MonthRangeSwitch_disabled__6baTw"};